import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material";
import {LangueService, WindowRefService} from '@app/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
    selector: 'app-lang',
    templateUrl: './lang.component.html',
    styleUrls: ['./lang.component.scss']
})

export class LangComponent implements OnInit {
    
    langs : {};
    langPlusUtil = [];
    defaultLang = { fr:'fr', ar:'ar', en:'en', ru:'ru', de:'de', it:'it', es:'es' };
    conteur : number = 0;
    selectedLang : string;

    constructor(private langueService: LangueService, public translate: TranslateService, private winRef: WindowRefService, @Inject(MAT_DIALOG_DATA) data) {
        this.langs = data.lang;
        this.selectedLang = this.winRef.appConfigSite.defaultlangue;
        data.lang.forEach(element => {
            if(element.code in this.defaultLang || element.code == this.selectedLang) {
                this.langPlusUtil[this.conteur] = element;
                this.conteur = this.conteur + 1;
            }
        });
    }

    ngOnInit() {
    }

    changeLang(value) {
        let promise = this.langueService.changeLang(value);
        promise.then( (rep)  => {
            let start = moment(this.winRef.appConfigSite.start).locale('en').format('YYYY-MM-DD'),
            end = moment(this.winRef.appConfigSite.end).locale('en').format('YYYY-MM-DD'),
            adults = this.winRef.appConfigSite.adults,
            enfants = this.winRef.appConfigSite.enfants,
            agesEnfants = this.winRef.appConfigSite.agesEnfants;
            this.winRef.generateNewUrlAndChanged(start, end, adults, enfants, agesEnfants);
        })
    }

    /**
    * lang
    * @returns string lang
    */
    get lang(): string {
        return this.winRef.appConfigSite.defaultlangue
    }
}